import React from 'react';
import { BodyText, Link } from '@placer-ui/components';
import {
    PRIVACY_POLICY_URL,
    TERMS_OF_SERVICE_URL,
} from 'features/authentication/signup/constants/signup-links';
import styles from './privacy-disclaimer.module.scss';

export const PrivacyDisclaimer = () => {
    return (
        <div className={styles.privacyDisclaimer}>
            <BodyText color="secondary" size="small">
                <div className={styles.disclaimerText}>
                    By clicking ‘Continue with Email’ you are agreeing to our
                </div>
            </BodyText>
            <div className={styles.linksContainer}>
                <Link href={PRIVACY_POLICY_URL} target="_blank" size="small" hideUnderline={false}>
                    Privacy Policy
                </Link>
                <BodyText color="secondary" size="small">
                    &
                </BodyText>
                <Link
                    href={TERMS_OF_SERVICE_URL}
                    target="_blank"
                    size="small"
                    hideUnderline={false}
                >
                    Terms of Service
                </Link>
            </div>
        </div>
    );
};
